import type { BillingProject, PaymentMethod } from '@teemill/billing';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const platformChargesWithoutBilling = ['own-brand', 'royalty', 'terms'];

export const useBillingStore = defineStore('billing', () => {
  const ready = ref(false);
  const billing = ref<BillingProject>();
  const paymentMethods = ref<PaymentMethod[]>();

  const hideBilling = computed(
    () =>
      !billing.value ||
      platformChargesWithoutBilling.includes(billing.value.settings.platform.charge),
  );

  return {
    ready,
    billing,
    paymentMethods,
    currency: computed(() => billing.value?.parentProject?.settings.currency || 'GBP'),
    hideBilling,
  };
});
